import { render } from "./JobNotificationPopup.vue?vue&type=template&id=0a5187dc&scoped=true"
import script from "./JobNotificationPopup.vue?vue&type=script&lang=js"
export * from "./JobNotificationPopup.vue?vue&type=script&lang=js"

import "./JobNotificationPopup.vue?vue&type=style&index=0&id=0a5187dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5187dc"]])

export default __exports__